import {
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
  OutlinedInput,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { compose } from "ramda";
import { ChangeEvent, memo, useState } from "react";
import { Control, Controller, UseFormMethods } from "react-hook-form";

import { getModelsBasedOnMakeCode } from "../../api/getModelsInfo";
import { makes } from "../../shared";
import { RootState } from "../../store";
import { withError } from "../HOC";
import { CommonFormElProps } from "../types";

import styles from "./SelectMake.module.scss";

export type SelectMakeItem = {
  readonly label: string;
  readonly value: string;
};

export type SelectMakeProps = {
  readonly items: Array<SelectMakeItem>;
  readonly control: Control;
  readonly trigger: UseFormMethods["trigger"];
} & CommonFormElProps;

export const SelectMake = memo<SelectMakeProps>(
  ({
    control,
    defaultValue,
    disabled: isDisabled,
    hasError,
    id,
    items,
    label,
    required = false,
    trigger,
    onChange: onChangeAction,
  }) => {
    const [otherMakeAvailability, setOtherMakeAvailability] = useState(false);

    const onMakeCodeChange = async (value: number) => {
      const modelData = await getModelsBasedOnMakeCode(value);
      onChangeAction(modelData?.models || []);
    };

    const findMakeCode = (selectedValue: string) => {
      const make = makes.find((make) => make.label === selectedValue);
      if (make) {
        return make.value;
      } else {
        return "0";
      }
    };

    return (
      <FormControl>
        <InputLabel
          shrink
          disabled={isDisabled}
          required={!isDisabled && required}
        >
          {label}
        </InputLabel>
        <div className={styles.container}>
          {!otherMakeAvailability ? (
            <Controller
              className={styles.controller}
              name={id}
              control={control}
              defaultValue={defaultValue}
              render={({ onChange, value }) => (
                <MuiSelect
                  className={styles.controller}
                  disabled={isDisabled}
                  error={hasError}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    onChange(selectedValue);
                    onMakeCodeChange(
                      parseInt(findMakeCode(selectedValue as string))
                    );
                  }}
                  id={id}
                  variant="outlined"
                  value={value}
                >
                  {items.map(({ label, value }) => (
                    <MenuItem key={value} value={label}>
                      {label}
                    </MenuItem>
                  ))}
                </MuiSelect>
              )}
            />
          ) : (
            <Controller
              name={id}
              control={control}
              className={styles.controller}
              defaultValue={defaultValue}
              as={
                <OutlinedInput
                  autoComplete="off"
                  defaultValue={defaultValue}
                  disabled={isDisabled}
                  error={hasError}
                  id={id}
                  inputProps={{
                    name: id,
                  }}
                />
              }
            ></Controller>
          )}
          <FormControlLabel
            control={
              <Checkbox
                color="secondary"
                checked={otherMakeAvailability}
                onChange={() => setOtherMakeAvailability((prev) => !prev)}
              />
            }
            label="Inne"
          />
        </div>
      </FormControl>
    );
  }
);

export const SelectMakeWithError = compose(withError)(SelectMake);
